// Centralized API configuration and authenticated fetch wrapper.
// Single source of truth for the backend base URL + JWT handling.
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3001/api";

const TOKEN_KEY = "mealPlannerToken";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
};
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

/**
 * Drop-in replacement for fetch():
 *  - accepts an absolute URL or a path relative to API_BASE_URL
 *  - attaches the JWT Bearer token automatically when present
 *  - clears the stored token on a 401 (session expired)
 */
export async function authFetch(input, options = {}) {
  const url = /^https?:\/\//.test(input)
    ? input
    : `${API_BASE_URL}${input.startsWith("/") ? "" : "/"}${input}`;

  const headers = new Headers(options.headers || {});
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const res = await fetch(url, { ...options, headers });
  if (res.status === 401) clearToken();
  return res;
}

export default authFetch;
